import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { AccountSetup } from 'components/account-setup/account-setup.component';
import { AllSet } from 'components/all-set/all-set.component';
import { BasePage } from 'components/base-page/base-page.component';
import { OnboardingFeatureHighlights } from 'components/onboarding-feature-highlights/onboarding-feature-highlights.component';
import { useOnboarding } from 'hooks/use-onboarding.hook';

export const PrivateRoutesContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const {
    userProfile,
    onAccountSetupComplete,
    onOnboardingComplete,
    onAllSetComplete,
    shouldShowAccountSetup,
    shouldShowFeatureHighlights,
    shouldShowAllSet,
    isLoading,
  } = useOnboarding();

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (shouldShowAccountSetup && userProfile) {
    return (
      <AccountSetup
        onComplete={onAccountSetupComplete}
        initialProfile={userProfile}
      />
    );
  }

  if (shouldShowFeatureHighlights) {
    return (
      <OnboardingFeatureHighlights
        onOnboardingComplete={onOnboardingComplete}
      />
    );
  }

  if (shouldShowAllSet) {
    return (
      <AllSet
        onGetStartedClick={onAllSetComplete}
        onNotNowClick={onAllSetComplete}
      />
    );
  }

  return <BasePage>{children}</BasePage>;
};
